import { render, staticRenderFns } from "./LearningGoalGradeForm.vue?vue&type=template&id=b0134934&"
import script from "./LearningGoalGradeForm.vue?vue&type=script&lang=js&"
export * from "./LearningGoalGradeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports